import React, { useEffect } from "react";
import { Container } from '@material-ui/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../../utils/swiper.util';
import GalleryCard from "../../../components/GalleryCard/list";
import { Link, useParams, useLocation } from 'react-router-dom';
import { fetchGallery } from "../../../services/gallery.service";
import translates from '../../../translation.json';
import { lang } from "../../../config/app.config";
import { useSelector } from "react-redux";
import { TranslationState } from '../../../store/ActionReducers/translation.actionreducer';
import { GalleryState } from "../../../store/ActionReducers/gallery.actionreducer";
import { useDispatch } from 'react-redux';

interface params {
  dist_slug: string
}

type LocationState = {
  pathname: string
}

const HomeGallery: React.FC = () => {

  const { dist_slug } = useParams<params>();
  const { pathname } = useLocation<LocationState>();
  const isProvince = pathname?.includes('province');

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGallery(1, dist_slug))
  }, []) //eslint-disable-line

  const state = useSelector((state: { translation: TranslationState }) => state.translation);
  const galleryState = useSelector((state: {
    gallery: GalleryState
  }) => state.gallery);

  const { loading, galleries } = galleryState;


  return (
    <>

      {
        loading ? "" :
          galleries ?
            <div className="bg-primary p-3">
              <Container maxWidth="lg" >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h3 className="text-20-primary mb-0">{state.translation ? state.translation.gallery[lang === 'np' ? 'value_np' : 'value_en'] : ''}</h3>
                  <div style={{ marginLeft: 'auto' }}>
                    {galleries?.length > 0 ?
                      <Link to={`/${lang}/${dist_slug ? `${isProvince ? 'province' : 'district'}/gallery/${dist_slug}` : 'gallery'}`} className="ecn-title text-14 mb-0" style={{ fontWeight: 500 }}>
                        {translates.translation[lang].view_all}
                      </Link>
                      : <></>}
                  </div>
                </div>
                <div className="mt-2">
                  {galleries?.length > 0 ?
                    < Swiper
                      observeParents={true}
                      observer={true}
                      // loop={true}
                      slidesPerView={1}
                      navigation
                      spaceBetween={15}
                      // pagination={{ clickable: true }}
                      breakpoints={{
                        776: {
                          slidesPerView: 3
                        },
                        992: {
                          slidesPerView: 4
                        }
                      }}
                      className="pb-0"
                    >
                      {galleries && galleries.length ?
                        galleries.map((gal, i) => (
                          <SwiperSlide key={i}>
                            <GalleryCard gallery={gal} />
                          </SwiperSlide>
                        )) : ''
                      }
                    </Swiper>
                    :
                    <p className="text-center section-break-4 text-16-primary">
                      {translates.translation[lang].no_galleries}
                    </p>
                  }

                  {/* <div className="text-center">
            <Link to={'/'+lang+"/gallery"}>
              <Button className="btn-primary">{translates.translation[lang].view_all}</Button>
            </Link>
          </div> */}
                </div>
              </Container>
            </div >
            : ''
      }
    </>
  );
}

export default HomeGallery;